module.exports = __webpack_public_path__ + "static/media/RLC.2e9246a7.svg";